export default __webpack_public_path__ + "static/media/pluto.975d0557.png";